export default function IconDone () {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.25831 3.1947C-0.0861035 3.53911 -0.0861035 4.09752 0.25831 4.44193L2.33703 6.52065C2.68145 6.86507 3.23985 6.86507 3.58427 6.52065L7.74171 2.36321C8.08612 2.0188 8.08612 1.46039 7.74171 1.11598C7.3973 0.771562 6.83889 0.771563 6.49448 1.11598L2.96065 4.6498L1.50554 3.1947C1.16113 2.85028 0.602724 2.85028 0.25831 3.1947Z"
        fill="#384146"/>
    </svg>
  )
}
